import React from 'react';
import sortBy from 'lodash/sortBy';
import { Cell } from 'styled-css-grid';

import { INotificationGridItem } from '../notification-grid';

import { DetailsRow } from './DetailsRow';

export const NewLeadsForTeamManagersDetails: React.FC<
  INotificationGridItem
> = ({ date, notificationDetails: { data } }) => {
  const managersLeadsSorted = sortBy(
    data.managersLeads,
    (item) => !item.isTeamManager
  );

  const managerList = managersLeadsSorted.map((manager, key) => {
    const generalInfo = `
      New Leads: ${manager.newLeadsIds.length},
      Without attempt: ${manager.newLeadsWithoutAttemptIds.length},
      Client IDs: ${manager.newLeadsWithoutAttemptIds.join(', ')},
    `;

    if (manager.isTeamManager) {
      return (
        <Cell key={key} width={2}>
          {`Team Manager: ${manager.managerFullName}, ${generalInfo}`}
        </Cell>
      );
    }

    return (
      <Cell key={key} width={2}>
        {`Manager ID: ${manager.managerId}, ${manager.managerFullName}, ${generalInfo}`}
      </Cell>
    );
  });

  return (
    <>
      <DetailsRow label="Date" value={date} />
      <DetailsRow label="New Group Leads" value={data.newLeadsTotalCount} />
      <DetailsRow
        label="Without attempt"
        value={data.newLeadsWithoutAttemptTotalCount}
      />
      {managerList}
    </>
  );
};
